export var AuditStatus;

(function (AuditStatus) {
  AuditStatus["APPROVED"] = "APPROVED";
  AuditStatus["PENDING"] = "PENDING";
  AuditStatus["REJECT"] = "REJECT";
})(AuditStatus || (AuditStatus = {}));